// API client using relative paths.
// In dev: vite.config.js proxies /apis → VITE_API_TARGET (default localhost:8080).
// In prod: nginx reverse-proxies /apis → backend.
//
// credentials: 'include' — same-origin nginx basic auth(/admin/* 등) 헤더를
// fetch 가 자동 동봉하도록. 페이지 navigation 으로 통과한 basic auth credential
// 을 XHR 에도 적용하려면 명시 필요 (특히 nginx 의 location 이 다를 때).

export class ApiError extends Error {
  constructor(status, code, message) {
    super(message);
    this.status = status;
    this.code = code;
  }
}

async function parseResponse(res) {
  const text = await res.text();
  const data = text ? JSON.parse(text) : null;

  if (!res.ok) {
    throw new ApiError(
      res.status,
      data?.code,
      data?.message || '요청 처리 중 오류가 발생했습니다.'
    );
  }
  return data;
}

export async function getJson(path) {
  const res = await fetch(path, {
    method: 'GET',
    credentials: 'include',
    headers: { Accept: 'application/json' },
  });
  return parseResponse(res);
}

export async function postJson(path, body) {
  const res = await fetch(path, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  return parseResponse(res);
}

export async function putJson(path, body) {
  const res = await fetch(path, {
    method: 'PUT',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  return parseResponse(res);
}

export async function deleteJson(path) {
  const res = await fetch(path, {
    method: 'DELETE',
    credentials: 'include',
  });
  return parseResponse(res);
}
